import { apiEndpoints } from '../constants/apiEndpoints';
import Service from './service';

const GetPubDates = async () => {
  try {
    const res = await Service.get(apiEndpoints.GET_PUBLISH_DATES);
    return res;
  } catch (error) {
    return error;
  }
};
export default GetPubDates;
